import { Button, Flex, notification } from "antd";
import React, { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSearch } from "../utils/CustomComponents";
import { useEffect } from "react";
import { useRef } from "react";
import { CSVLink } from "react-csv";
import { customerTypeOptions } from "../../constants/Customer";

const columns = [
	{ key: "name", label: "Name" },
	{ key: "phone", label: "Phone" },
	{ key: "email", label: "Email" },
	{ key: "address", label: "Address" },
];

const CustomersByType = ({ onSuccess }) => {
	const [loading, setLoading] = useState(true);
	const [loadingButton, setLoadingButton] = useState(false);
	const [customerType, setCustomerType] = useState(undefined);
	const [data, setData] = useState([]);
	const refDownload = useRef();

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		if (customerType) {
			getCustomers();
		}
	}, [customerType]);

	const getCustomers = async () => {
		setLoading(true);
		setLoadingButton(true);
		const url = api + `/customer/get/list/type/${customerType}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						name: item.customerNumber
							? `${item.customerNumber} - ${item.name}`
							: item.name,
						address: item.address,
						phone: item.sms,
						email: item.email,
					});
				});
				setData(list);
				setLoading(false);
				setLoadingButton(false);
				openNotification(
					"success",
					"Success",
					"Customers by type retrieved successfully",
				);
			} else {
				setLoading(false);
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.label,
			};
		});
	};

	const CustomForm = () => {
		return (
			<Flex vertical gap={10}>
				<CustomSearch
					labelPicker={"customer type"}
					optionsPicker={customerTypeOptions}
					onChangePicker={(v) => setCustomerType(v)}
					pickerValue={customerType}
					allowClearPicker={true}
					pickerWidth="200px"
				/>

				<CSVLink
					data={data}
					headers={headers()}
					filename={"57concrete-customertype-report.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Button
					size="large"
					type="primary"
					style={{ width: "170px" }}
					onClick={(e) => refDownload.current.link.click()}
					loading={loadingButton}
					disabled={loading}
				>
					Download CSV
				</Button>
			</Flex>
		);
	};

	return (
		<>
			{contextHolder}
			<CustomForm />
		</>
	);
};

export default CustomersByType;
